import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { SelectModule } from 'ng2-select';
import { ComponentsModule } from '../shared/components/components.module';

import { MaterialModule } from '../app.module';
import { CustomersRoutes } from './customers.routing';
import { CustomersComponent, NuevoPaciente } from './customers.component';
import { CustomersTableComponent } from './customers-table/customers-table.component';
// import { NuevoClienteComponent } from './nuevo-cliente/nuevo-cliente.component';
//import {  NuevoCompany} from '../tables/listcompany/listcompany.component';



@NgModule({
    imports: [
        CommonModule,
         RouterModule.forChild(CustomersRoutes),
        FormsModule,
        ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    ComponentsModule
    ],
    declarations: [CustomersComponent, 
   // NuevoCompany, 
    NuevoPaciente, CustomersTableComponent],
    entryComponents: [CustomersComponent, NuevoPaciente
     //,NuevoCompany
     ], exports: [NuevoPaciente]
})

export class CustomersModule {}